export enum NotificationType {
  COMMENT_MENTION = 'COMMENT_MENTION',
  CONNECT_FIVE_CHALLENGE = 'CONNECT_FIVE_CHALLENGE',
  EXCHANGE_ORDER_FILLED = 'EXCHANGE_ORDER_FILLED',
  POST_COIN_TRANSFER = 'POST_COIN_TRANSFER',
  POST_COMMENT = 'POST_COMMENT',
  POST_LIKE = 'POST_LIKE',
  POST_MENTION = 'POST_MENTION',
  PROFILE_FOLLOW = 'PROFILE_FOLLOW',
}
